import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=3173b066&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=3173b066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3173b066",
  null
  
)

export default component.exports